/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function IdLinkCell({ id, checked, object }) {
  const navigate = useNavigate()
  const user = useSelector( state => state.user)

  var path = "/fb/app/home/view-estate-ticket?id=" + object.id
  
  switch (object.Object_Type){
    case "Estate":
      path = "/fb/app/home/view-estate-ticket"
      break;
    case "Property_Group":
      path = "/fb/app/home/view-property-group-ticket"
      break;
    case "Building":
      path = "/fb/app/home/view-building-ticket"
      break;
    case "Space":
      path = "/fb/app/home/view-space-ticket"
      break;
    case "Asset":
      path = "/fb/app/home/view-asset-ticket"
      break;
  }


  const handleSubmit = ()=>{
    if (object.Ticket_Action_Type === "BatchCreate" || object.Ticket_Action_Type === "BatchUpdate"){
      path += "-batch"
    }
    
    navigate(path +"?id=" + object.id, {state: object})
  }

  return (
    <MDBox display="flex" alignItems="center">
      <MDBox ml={1}>
        <MDButton 
          variant="text" 
          color="info" 
          onClick={handleSubmit}
          sx={{marginleft: "0", paddingLeft: "0"}}
        >
          {id}
        </MDButton>
      </MDBox>
    </MDBox>
  );
}

// Setting default value for the props of IdCell
IdLinkCell.defaultProps = {
  checked: false,
};

// Typechecking props for the IdCell
IdLinkCell.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
};

export default IdLinkCell;
